import React from 'react';
import { RightOutlined, DownOutlined } from '@ant-design/icons';
import { ViewModeState } from '../../constants';
import './SwitchSummaryViewMode.scss';

export const SwitchSummaryViewMode = ({ value, onChange, disabled, className = '' }) => {
    const isOpen = value === ViewModeState.OPEN;

    const handleClick = () => {
        if (disabled) {
            return;
        }
        onChange(isOpen ? ViewModeState.HIDDEN : ViewModeState.OPEN);
    };

    return (
        <button
            type="button"
            onClick={handleClick}
            disabled={disabled}
            className={`switch-summary-view-mode ${className}`}
        >
            {isOpen ? <DownOutlined /> : <RightOutlined />}
        </button>
    );
};
